<template>
  <div class="schedule-selector">
    <div class="selected-item">
      <b-form-input
        class="selected-item-input"
        v-bind:size="formSize"
        readonly
        v-bind:value="selectedNames"
        v-on:click="$_showDialog"
      />
    </div>
    <ifield-b-modal
      v-bind:id="modalId"
      v-bind:title="$t('appScheduleSelector.selectSchedules')"
      v-bind:ok-title="$t('appScheduleSelector.action.select')"
      v-bind:cancel-title="$t('appScheduleSelector.action.cancel')"
      ignore-enforce-focus-selector=".popover"
      ok-variant="success"
      size="lg"
      centered
      v-on:ok="$_fixSelectedItems"
      v-on:show="$_initializeSearchParams"
    >
      <loading-mask
        v-bind:isLoading="isLoading"
        v-bind:isFullScreen="isLoadingFullScreen"
      >
        <div class="content-inner">
          <!-- 絞り込み -->
          <div class="tool-bar">
            <!-- ユーザー -->
            <user-selector
              v-bind="userSelectorProps"
              v-bind:keywordTarget="
                $store.getters['userKeywordTarget/keywordTargets']
              "
              v-bind:onApiError="handleApiError"
              v-on:change:value="$_onUserSelectend"
              v-on:change:keywordTarget="
                $store.dispatch('userKeywordTarget/setKeywordTargets', $event)
              "
            />
            <!-- 日付 -->
            <datetime-selector
              v-bind="datetimeSelectorProps"
              v-on:datetime-selectend="$_onDatetimeSelectend"
            />
            <!-- 完了状態 -->
            <div class="filtering-group">
              <b-button-group class="filtering-button-group">
                <b-button
                  size="sm"
                  v-for="button in filterButtons"
                  v-bind:key="button.key"
                  v-bind:variant="
                    searchParams.isCompleted === button.value
                      ? 'success'
                      : 'light'
                  "
                  v-on:click="$_onIsCompletedChange(button.value)"
                >
                  {{ $t(button.text) }}
                </b-button>
              </b-button-group>
            </div>
          </div>
          <!-- アイテム一覧 -->
          <div class="selector-data-list">
            <table class="table table-hover selector-table">
              <thead class="thead-light">
                <tr>
                  <th scope="col" class="field field-checkbox">
                    <b-form-checkbox
                      v-if="isSelectTypeMultiple"
                      v-model="isSelectedAllCurrentItems"
                      v-bind:indeterminate="indeterminate"
                      v-bind:disabled="isSelectedAllItems"
                      v-on:change="$_toggleAllItems"
                    />
                  </th>
                  <th v-if="withId" scope="col" class="field field-item-id">
                    {{ $t('appScheduleSelector.title.id') }}
                  </th>
                  <th scope="col" class="field field-item-period">
                    {{ $t('appScheduleSelector.title.dateTime') }}
                  </th>
                  <th scope="col" class="field field-item-name">
                    {{ $t('appScheduleSelector.title.title') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-for="item in items">
                  <tr
                    v-bind:key="item.id"
                    v-bind:id="`${modalId}-${item.id}`"
                    v-bind:class="{
                      'all-item-row': item.id === ALL_ITEMS_RECORD.id,
                    }"
                    v-on:click="$_onClickItem(item.id)"
                  >
                    <td>
                      <!-- 複数選択用チェックボックス -->
                      <!-- inputイベントのemit回避のためネイティブのinputを使用 -->
                      <div
                        v-if="isSelectTypeMultiple"
                        class="custom-control custom-checkbox"
                      >
                        <!-- すべてのアイテム -->
                        <input
                          v-if="item.id === ALL_ITEMS_RECORD.id"
                          type="checkbox"
                          class="custom-control-input"
                          v-bind:id="`${modalId}-check-${item.id}`"
                          v-bind:checked="isSelectedAllItems"
                        />
                        <!-- 各アイテム -->
                        <input
                          v-else
                          type="checkbox"
                          class="custom-control-input"
                          v-bind:id="`${modalId}-check-${item.id}`"
                          v-bind:value="item.id"
                          v-bind:disabled="isSelectedAllItems"
                          v-bind:checked="multiSelectedIdSet.has(item.id)"
                        />
                        <label
                          class="custom-control-label"
                          v-bind:for="`${modalId}-check-${item.id}`"
                        />
                      </div>
                      <!-- 単一選択用ラジオボタン -->
                      <!-- inputイベントのemit回避のためネイティブのinputを使用 -->
                      <div
                        v-if="!isSelectTypeMultiple"
                        class="custom-control custom-radio"
                      >
                        <input
                          type="radio"
                          class="custom-control-input"
                          v-bind:id="`${modalId}-radio-${item.id}`"
                          v-bind:value="item.id"
                          v-bind:checked="item.id === singleSelectedId"
                        />
                        <label
                          class="custom-control-label"
                          v-bind:for="`${modalId}-radio-${item.id}`"
                        />
                      </div>
                    </td>
                    <td v-if="withId">
                      <div class="item-col">
                        <h6 class="item-text">
                          {{ item.id === ALL_ITEMS_RECORD.id ? '' : item.id }}
                        </h6>
                      </div>
                    </td>
                    <td>
                      <div class="item-col">
                        <h6 class="item-text">
                          {{ $_getDisplayPeriod(item) }}
                        </h6>
                      </div>
                    </td>
                    <td>
                      <div class="item-col">
                        <h6 class="item-text">
                          {{ item.title }}
                        </h6>
                      </div>
                    </td>
                  </tr>
                  <!-- ポップオーバー -->
                  <b-popover
                    v-bind:key="`${item.id}-popover`"
                    v-bind:target="`${modalId}-${item.id}`"
                    placement="left"
                    triggers="hover"
                    custom-class="row-popover"
                  >
                    <h3 class="item-name">
                      {{ item.title }}
                    </h3>
                    <data-list
                      class="data-list"
                      v-bind:data="$_getDataList(item)"
                    />
                  </b-popover>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </loading-mask>
    </ifield-b-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { RestApiClient } from 'ifield-core-components'
import {
  MINIMUM_TIME,
  MAXIMUM_TIME,
  DATE_FORMAT_HYPHEN,
  TIME_FORMAT_MINUTE,
  DATETIME_FORMAT_API,
} from '@/constants.js'
import DataList from '@/components/AppDataList.vue'
import Schedule from '@/model/Schedule.js'
import { toLocalTz, toServerTz } from '@/js/TimezoneHelper'
import SchedulePeriodFormatter from '@/js/SchedulePeriodFormatter.js'
import { useHandleApiError } from '@/composables/UseHandleApiError.js'

// 選択種別
const SELECT_TYPES = {
  SINGLE: 0,
  MULTIPLE: 1,
}
// 絞り込みボタン定義
const FILTER_BUTTONS = [
  { key: 'all', value: null, text: 'appScheduleSelector.filter.all' },
  { key: 'notYet', value: false, text: 'appScheduleSelector.filter.notYet' },
  {
    key: 'completed',
    value: true,
    text: 'appScheduleSelector.filter.completed',
  },
]
// 「すべてのアイテム」用ID
const ALL_ITEMS_ID = -1
// デフォルトの検索条件
const DEFAULT_SEARCH_PARAMS = {
  userId: null,
  organizationId: null,
  from: null,
  to: null,
  isCompleted: null,
}

/**
 * API取得したスケジュールデータをローカルタイムゾーンに変換する
 * @param {Object[]} data API取得したスケジュールデータ
 * @returns {Object[]} ローカルタイムゾーンに変換したスケジュールデータ
 */
const toLocalTzSchedules = (data) =>
  data.map((d) =>
    d.allday_flg
      ? d
      : {
          ...d,
          start_at: toLocalTz(d.start_at),
          end_at: toLocalTz(d.end_at),
        }
  )

/**
 * スケジュール選択コンポーネント
 */
export default {
  name: 'AppScheduleSelector',
  components: {
    'data-list': DataList,
  },
  props: {
    /**
     * 選択されているスケジュールIDのデフォルト値
     */
    defaultIds: {
      type: Array,
      default: () => [],
    },
    /**
     * 選択種別 (0:単一, 1:複数)
     *
     * 初期値:
     *
     * ```
     * SELECT_TYPES.MULTIPLE = 1
     * ```
     *
     * @values 0, 1
     */
    selectType: {
      type: Number,
      default: SELECT_TYPES.MULTIPLE,
    },
    /**
     * 「すべてのスケジュール」を選択している時に表示されるラベル
     */
    selectedAllItemLabel: {
      type: String,
      required: true,
    },
    /**
     * IDを表示する場合はtrue
     */
    withId: {
      type: Boolean,
      default: false,
    },
    /**
     * DOMのidのプレフィックス
     *
     * 1画面に本コンポーネントを複数配置する場合は設定が必要です
     */
    idPrefix: {
      type: String,
      default: '',
    },
    /**
     * 「すべてのスケジュール」を選択可能にする場合はtrue
     */
    allItemsSelectable: {
      type: Boolean,
      default: false,
    },
    /**
     * フォームのサイズ
     *
     * @values 'sm', 'md', 'xl'
     */
    formSize: {
      type: String,
      default: 'sm',
    },
    /**
     * 検索条件の初期値
     *
     * ```
     * {
     *   // user_id に指定する値
     *   userId: number[]|null;
     *   // organization_id に指定する値
     *   organizationId: number[]|null;
     *   // from に指定する値
     *   from: srting;
     *   // to に指定する値
     *   to: string;
     *   // complete_flg に指定する値
     *   isCompleted: boolean,;
     * }
     * ```
     */
    defaultSearchParams: {
      type: Object,
      default: () => DEFAULT_SEARCH_PARAMS,
    },
  },
  setup(props, context) {
    const { handleApiError } = useHandleApiError(props, context)
    return { handleApiError }
  },
  data: function () {
    return {
      /**
       * 「すべてのアイテム」レコード
       * @type {Object}
       */
      ALL_ITEMS_RECORD: {
        id: ALL_ITEMS_ID,
        title: this.selectedAllItemLabel,
      },
      /**
       * アイテム一覧
       * @type {Array}
       */
      items: [],
      /**
       * アイテムのMap
       * @type {Map}
       */
      itemMap: new Map(),
      /**
       * 表示中のアイテムのMap
       * @type {Map}
       */
      currentItemMap: new Map(),
      /**
       * 検索条件
       * @param {Object}
       */
      searchParams: { ...DEFAULT_SEARCH_PARAMS, ...this.defaultSearchParams },
      /**
       * 期間のバリデーション状態
       * @type {Boolean}
       */
      datetimeValidateState: null,
      /**
       * 選択されているアイテム(複数用)
       * @type {Array.<Number>}
       */
      multiSelectedIds: [],
      /**
       * 選択されているアイテム(単一用)
       * @type {Number}
       */
      singleSelectedId: null,
      /**
       * 選択されているアイテム名(確定済み)
       * @type {String}
       */
      selectedNames: null,
      /**
       * 表示中のアイテムをすべて選択している場合はtrue
       * @type {Boolean}
       */
      isSelectedAllCurrentItems: false,
      /**
       * 「すべてのアイテム」を選択している場合はtrue
       * @type {Boolean}
       */
      isSelectedAllItems: false,
      /**
       * 表示されているアイテム一覧のアイテムを一部選択している場合はtrue
       * @type {Boolean}
       */
      indeterminate: false,
      /**
       * 選択が確定しているID
       * @type {Array.<Number>}
       */
      confirmedIds: Array.isArray(this.defaultIds)
        ? [...this.defaultIds]
        : [this.defaultIds],
      /**
       * ロード中ならtrue
       * @type {Boolean}
       */
      isLoading: false,
      /**
       * ローディングをフルスクリーン表示する場合はtrue
       * @type {Boolean}
       */
      isLoadingFullScreen: false,
    }
  },
  computed: {
    /**
     * 絞り込み用ボタン定義
     * @type {Array.<Object>}
     */
    filterButtons: function () {
      return FILTER_BUTTONS
    },
    /**
     * 選択種別
     * @type {Object}
     */
    SELECT_TYPES: function () {
      return SELECT_TYPES
    },
    /**
     * 選択タイプが複数の場合はtrue
     * @type {Boolean}
     */
    isSelectTypeMultiple: function () {
      return this.selectType === this.SELECT_TYPES.MULTIPLE
    },
    /**
     * 選択されているIDのSet(複数用)
     * @type {Set}
     */
    multiSelectedIdSet: function () {
      return new Set(this.multiSelectedIds)
    },
    /**
     * 選択されているID
     * @type {Array.<Number>}
     */
    selectedIds: function () {
      if (this.isSelectTypeMultiple) {
        // 複数選択の場合
        const selectedIds = [...this.multiSelectedIds]
        // IDでソートする(selectedIdsは選択した順に入っているため)
        return selectedIds.sort((a, b) => a - b)
      } else {
        // 単一選択の場合
        return this.singleSelectedId ? [this.singleSelectedId] : []
      }
    },
    /**
     * ユーザー選択用の値
     * @type {Objcet[]}
     */
    valueForUserSelector: function () {
      const { userId, organizationId } = this.searchParams
      if (!userId && !organizationId) return null
      return [
        ...(organizationId || []).map((id) => ({
          type: 'organization',
          id,
        })),
        ...(userId || []).map((id) => ({ type: 'user', id })),
      ]
    },
    /**
     * AppUserSelector用props
     * @type {Object}
     */
    userSelectorProps: function () {
      return {
        allOrganizations: true,
        primaryOrganizationId:
          this.$store.getters['userProfile/defaultOrganizationId'],
        indoorSites: this.$store.getters['indoorSite/indoorSites'],
        defaultText: this.$t('appScheduleSelector.allUsers'),
        keywordTarget: this.$store.getters['user/keywordTargets'],
        onApiError: this.handleApiError,
        value: this.valueForUserSelector,
      }
    },
    /**
     * 日時選択に渡す初期値
     * @type {Object}
     */
    defaultDatetimes: function () {
      let [startDate, startTime, endDate, endTime] = [null, null, null, null]

      const fromMoment = moment(this.searchParams.from)
      const toMoment = moment(this.searchParams.to)
      if (this.searchParams.from && fromMoment.isValid()) {
        startDate = fromMoment.format(DATE_FORMAT_HYPHEN)
        startTime = fromMoment.format(TIME_FORMAT_MINUTE)
      }
      if (this.searchParams.to && toMoment.isValid()) {
        endDate = toMoment.format(DATE_FORMAT_HYPHEN)
        endTime = toMoment.format(TIME_FORMAT_MINUTE)
      }

      return {
        startDate,
        startTime,
        endDate,
        endTime,
      }
    },
    /**
     * AppDatetimeSelector用props
     * @type {Object}
     */
    datetimeSelectorProps: function () {
      return {
        timeFlg: true,
        periodFlg: true,
        periodString: '〜',
        state: this.datetimeValidateState,
        ...this.defaultDatetimes,
      }
    },
    /**
     * 検索ユーザーが設定されている場合はtrue
     * @type {Boolean}
     */
    isSetUserId: function () {
      return this.searchParams.userId?.length > 0
    },
    /**
     * 検索グループが設定されている場合はtrue
     * @type {Boolean}
     */
    isSetOrganizationId: function () {
      return this.searchParams.organizationId?.length > 0
    },
    /**
     * 検索期間が設定されている場合はtrue
     * @type {Boolean}
     */
    isSetPeriod: function () {
      return this.searchParams.from !== null || this.searchParams.to !== null
    },
    /**
     * 完了状態が設定されている場合はtrue
     * @type {Boolean}
     */
    isSetIsCompleted: function () {
      return this.searchParams.isCompleted !== null
    },
    /**
     * 絞り込み中の場合はtrue
     * @type {Boolean}
     */
    isFiltering: function () {
      return this.isSetUserId || this.isSetPeriod || this.isSetIsCompleted
    },
    /**
     * 「すべてのアイテム」レコードを追加する場合はtrue
     * @type {Boolean}
     */
    withAllItems: function () {
      return (
        this.allItemsSelectable &&
        this.isSelectTypeMultiple &&
        !this.isFiltering
      )
    },
    /**
     * モーダルのID
     * @type {String}
     */
    modalId: function () {
      return `${this.idPrefix}schedule-dialog`
    },
  },
  created: function () {
    this.formatter = new SchedulePeriodFormatter({
      allDayText: this.$t('appScheduleSelector.allDay'),
    })
    this.$_updateIndoorSites()
    this.$_initializeSelections()
    this.$_showSelectedName()
  },
  mounted: function () {
    this.$log.info('scheduleSelector mounted!')
  },
  watch: {
    multiSelectedIds: function () {
      // 全件チェックボックスの更新
      this.$_setSelectedAllStatus()
    },
    searchParams: {
      handler: function () {
        // リスト更新
        this.$_showItems()
      },
      deep: true,
    },
  },
  methods: {
    /**
     * サイトデータ更新
     */
    $_updateIndoorSites: async function () {
      try {
        this.$store.dispatch('indoorSite/updateIndoorSitesWithThrottle')
      } catch (error) {
        this.handleApiError(error, () => {
          this.$log.info('failed to fetch indoor sites. use fetched before.')
        })
      }
    },

    /**
     * 選択状態を初期化する
     */
    $_initializeSelections: function () {
      // 全件選択フラグを分離
      const allItemsIndex = this.confirmedIds.indexOf(ALL_ITEMS_ID)
      if (allItemsIndex !== -1) {
        this.confirmedIds.splice(allItemsIndex, 1)
        this.isSelectedAllItems = this.allItemsSelectable
      }

      // 各表示用配列を初期化
      this.multiSelectedIds = [...this.confirmedIds]
      this.singleSelectedId =
        this.confirmedIds.length > 0 ? this.confirmedIds[0] : null
    },

    /**
     * 選択されているアイテムの名称を表示する
     */
    $_showSelectedName: async function () {
      // 全件選択フラグがtrueなら「すべてのアイテム」ラベルのみを表示
      if (this.isSelectedAllItems) {
        this.selectedNames = this.$_createSelectedNames([])
        return
      }

      // 選択されているアイテムを取得してitemMapを更新
      if (this.selectedIds.length > 0) {
        await this.$_getSpecificItems(this.selectedIds)
      }

      // 削除されているアイテムの選択を取り除く
      this.$_removeDeletedItemsSelection()

      const itemNames = this.selectedIds
        .filter((id) => this.itemMap.has(id))
        .map((id) => this.itemMap.get(id).title)

      // 選択したアイテムの名称をテキストボックスに表示する
      this.selectedNames = this.$_createSelectedNames(itemNames)
    },

    /**
     * テキストボックスに表示するための名称を作成する
     *
     * @param {Array.<String>} names 名称配列
     * @return {string} 選択されている名称
     */
    $_createSelectedNames: function (names) {
      return names.length === 0 ? this.selectedAllItemLabel : names.join(',')
    },

    /**
     * 指定IDのアイテムを取得する
     * @param {Array.<Number>} ids ID配列
     */
    $_getSpecificItems: async function (ids) {
      const url = RestApiClient.createApiUrl('schedule')
      const params = url.searchParams
      params.append('id', ids.join(','))
      try {
        const json = await RestApiClient.executeGetApi(url)
        const data = toLocalTzSchedules(json.data)
        this.$_updateItemMap(data)
        return data
      } catch (error) {
        this.handleApiError(error, () => {
          this.$log.warn('failed to fetch schedules. use fetched before.')
        })
      }
    },

    /**
     * 削除されているアイテムの選択を取り除く
     */
    $_removeDeletedItemsSelection: function () {
      this.multiSelectedIds = this.multiSelectedIds.filter((id) =>
        this.itemMap.has(id)
      )
      if (!this.itemMap.has(this.singleSelectedId)) {
        this.singleSelectedId = null
      }
    },

    /**
     * 表示用日時を取得する
     *
     * @param {Schedule} schedule スケジュール
     */
    $_getDisplayPeriod: function (schedule) {
      return this.formatter.format(schedule)
    },

    /**
     * 値をセットする
     *
     * @param {Array.<Number>|Number} ids ID値
     * @param {Boolean} [emitEvent=true] 選択イベントを発行する場合はtrue
     * @public
     */
    setValue: function (ids, emitEvent = true) {
      const value = Array.isArray(ids) ? ids : [ids]
      if (this.isSelectTypeMultiple) {
        this.multiSelectedIds = value
      } else {
        if (value.length > 1) {
          // 複数指定している場合は無効
          this.$log.warn(
            'Not allowed to set multiple ids when single select type.'
          )
          return
        }
        this.singleSelectedId = value[0]
      }
      this.$_fixSelectedItems(emitEvent)
    },

    /**
     * 選択ダイアログを表示する
     */
    $_showDialog: function () {
      this.$bvModal.show(this.modalId)
    },

    /**
     * 選択状態を初期化する
     */
    $_initializeSearchParams: function () {
      // 検索条件を初期化する
      const newParams = {
        ...DEFAULT_SEARCH_PARAMS,
        ...this.defaultSearchParams,
      }
      // 開始日時調整
      if (!newParams.from) {
        newParams.from = moment().startOf('hour').format(DATETIME_FORMAT_API)
      }
      this.searchParams = newParams
      // 期間選択のバリデーション状態も初期化
      this.datetimeValidateState = null
    },

    /**
     * アイテム一覧を表示する
     */
    $_showItems: async function () {
      this.$_showLoading()

      try {
        const data = await this.$_getItems()
        this.$_replaceItems(data)
      } catch {
        // エラー時は表示中のリストを維持する
      } finally {
        this.$_hideLoading()
      }
    },

    /**
     * アイテムを取得する
     *
     * GET /schedule はページング(limit/offset)未サポートのため、
     * 条件一致の全件が一括で返却される (IFIELD_V4-7010)
     */
    $_getItems: async function () {
      const url = RestApiClient.createApiUrl('schedule')
      const params = url.searchParams
      // ユーザーID
      if (this.isSetUserId) {
        params.append('user_id', this.searchParams.userId.join(','))
      }
      // 組織ID
      if (this.isSetOrganizationId) {
        params.append(
          'organization_id',
          this.searchParams.organizationId.join(',')
        )
      }
      // 期間
      if (this.isSetPeriod) {
        this.searchParams.from !== null &&
          params.append('from', toServerTz(this.searchParams.from))
        this.searchParams.to !== null &&
          params.append('to', toServerTz(this.searchParams.to))
      }
      // 完了状態
      if (this.isSetIsCompleted) {
        params.append('complete_flg', this.searchParams.isCompleted)
      }

      try {
        const json = await RestApiClient.executeGetApi(url)
        const data = toLocalTzSchedules(json.data)
        this.$_updateItemMap(data)
        return data
      } catch (error) {
        this.handleApiError(error)
        throw error
      }
    },

    /**
     * アイテムデータを置き換える
     *
     * @param {Array.<Object>} data 置き換えるデータ
     */
    $_replaceItems: function (data) {
      this.items = data.map((datum) => new Schedule(datum))
      this.$_updateCurrentItemMap()
      this.withAllItems && this.$_appendAllItemsRecord()
      this.$_setSelectedAllStatus()
    },

    /**
     * 「すべてのアイテム」レコードを追加する
     */
    $_appendAllItemsRecord: function () {
      this.items.splice(0, 0, this.ALL_ITEMS_RECORD)
    },

    /**
     * itemMapを更新する
     *
     * @param {Array.<Object>} data 更新データ
     */
    $_updateItemMap: function (data) {
      for (const item of data) {
        this.itemMap.set(item.id, new Schedule(item))
      }
    },

    /**
     * currentItemMapを更新する
     */
    $_updateCurrentItemMap: function () {
      this.currentItemMap = new Map()
      for (const item of this.items) {
        if (item.id !== ALL_ITEMS_ID) {
          this.currentItemMap.set(item.id, item)
        }
      }
    },

    /**
     * ユーザー選択終了時の処理
     *
     * @param {Array.<Object>} value 選択値
     */
    $_onUserSelectend: function (value) {
      if (!value) {
        this.searchParams = {
          ...this.searchParams,
          userId: null,
          organizationId: null,
        }
        return
      }

      const { userId, organizationId } = (value || []).reduce(
        (result, current) => {
          const { type, id } = current
          if (type === 'user') {
            result.userId.push(id)
          } else if (type === 'organization') {
            result.organizationId.push(id)
          }
          return result
        },
        { userId: [], organizationId: [] }
      )

      this.searchParams = {
        ...this.searchParams,
        userId,
        organizationId,
      }
    },

    /**
     * 期間選択終了時の処理
     *
     * @param {String} startDate 開始日
     * @param {String} startTime 開始時刻
     * @param {String} endDate 終了日
     * @param {String} endTime 終了時刻
     * @param {String} errorMessage エラーメッセージ
     */
    $_onDatetimeSelectend: function (
      startDate,
      startTime,
      endDate,
      endTime,
      errorMessage
    ) {
      if (errorMessage) {
        this.$log.warn(errorMessage)
        this.datetimeValidateState = false
        return
      }

      this.datetimeValidateState = true
      let from = null
      let to = null
      if (startDate) {
        const time = startTime || MINIMUM_TIME
        from = `${startDate}T${time}`
      }
      if (endDate) {
        const time = endTime || MAXIMUM_TIME
        to = `${endDate}T${time}`
      }

      // watchが複数回走らないように一気に設定する
      const params = { ...this.searchParams }
      params.from = from
      params.to = to
      this.searchParams = params
    },

    /**
     * 完了状態変更時の処理
     *
     * @param {Boolean} value 変更値
     */
    $_onIsCompletedChange: function (value) {
      this.searchParams.isCompleted = value
    },

    /**
     * DataListに表示項目を取得する
     *
     * @param {Schedule} item 対象アイテム
     */
    $_getDataList: function (item) {
      return {
        standard: [
          {
            label: this.$t('appScheduleSelector.field.dateTime'),
            value: this.formatter.format(item),
          },
          {
            label: this.$t('appScheduleSelector.field.comment'),
            value: item.detail,
          },
          {
            label: this.$t('appScheduleSelector.field.isCompleted'),
            value: item.isCompleted ? '○' : '×',
          },
          {
            label: this.$t('appScheduleSelector.field.place'),
            value: item.checkinTask && item.placeName,
          },
          {
            label: this.$t('appScheduleSelector.field.reportProject'),
            value: item.reportTask && item.reportProjectName,
          },
          {
            label: this.$t('appScheduleSelector.field.targetUsers'),
            value: [
              ...(item.targetOrganizations || []).map(
                (o) =>
                  `${o.organization_name} (${o.organization_user_relations.length})`
              ),
              ...(item.targetUsers || []).map((user) => user.user_name),
            ].join(', '),
          },
        ],
      }
    },

    /**
     * アイテム選択終了時のイベントを発生させる
     *
     * @param {Boolean} [emitEvent=true] 選択イベントを発行する場合はtrue
     */
    $_fixSelectedItems: async function (emitEvent = true) {
      // フルスクリーンでローディング表示
      this.$_showLoadingFullScreen()

      // 確定済みのユーザーIDを保持しておく
      this.confirmedIds = [...this.selectedIds]

      let retItems = []
      let itemNames = []
      if (this.isSelectedAllItems) {
        retItems = [
          {
            id: this.ALL_ITEMS_RECORD.id,
            title: this.ALL_ITEMS_RECORD.title,
          },
        ]
        itemNames = [this.ALL_ITEMS_RECORD.title]
      } else {
        // 選択されているアイテムを取得してitemMapを更新
        if (this.confirmedIds.length > 0) {
          await this.$_getSpecificItems(this.confirmedIds)
        }

        // イベントの戻値と表示用名称配列を作成
        this.confirmedIds
          .filter((id) => this.itemMap.has(id))
          .forEach((id) => {
            const name = this.itemMap.get(id).title
            retItems.push({ id, name })
            itemNames.push(name)
          })
      }

      // 選択したアイテムの名称をテキストボックスに表示する
      this.selectedNames = this.$_createSelectedNames(itemNames)

      if (emitEvent) {
        /**
         * スケジュール選択終了時のイベント
         *
         * 選択されたスケジュールID, 名前を配列で返却する
         *
         * ```
         * ex)
         * // 通常スケジュール選択時
         * [
         *   {
         *     id: 1,
         *     name: 'マルティスープ',
         *   },
         * ]
         *
         * // 「すべてのスケジュール」選択時
         * [
         *   {
         *     id: -1,
         *     name: this.selectedAllItemsLabel,
         *   },
         * ]
         * ```
         *
         * @param {Array.<Object>} schedules スケジュールID, 名前の配列
         */
        this.$emit('schedule-selectend', retItems)
      }

      // ローディング表示終了
      this.$_hideLoadingFullScreen()
    },

    /**
     * アイテムの選択状態を一括で変更する
     *
     * @param {Boolean} checked 変更する値
     */
    $_toggleAllItems: function (checked) {
      // 選択済みID配列の更新
      if (checked) {
        // 未選択のアイテムを追加する
        const selectedIds = [...this.multiSelectedIds]
        this.currentItemMap.forEach((item) => {
          !selectedIds.includes(item.id) && selectedIds.push(item.id)
        })
        this.multiSelectedIds = selectedIds
      } else {
        if (this.isFiltering) {
          // 現在のアイテム一覧に表示されているアイテムを選択済みのリストから除外する
          // (現在の一覧に表示されていないアイテムは選択済みのままとなる)
          let newSelectedIds = []
          this.multiSelectedIds.forEach((id) => {
            if (!this.currentItemMap.has(id)) {
              newSelectedIds.push(id)
            }
          })
          this.multiSelectedIds = newSelectedIds
        } else {
          // 表示されていないアイテムも含めて全て選択解除する
          this.multiSelectedIds = []
        }
      }
    },

    /**
     * 全件チェックボックスの状態を設定する
     */
    $_setSelectedAllStatus: function () {
      const count = this.multiSelectedIds.filter((id) =>
        this.currentItemMap.has(id)
      ).length

      if (count === 0) {
        // 表示されているアイテム一覧のアイテムが未選択
        this.indeterminate = false
        this.isSelectedAllCurrentItems = false
      } else if (count === this.currentItemMap.size) {
        // 表示されているアイテム一覧のアイテムがすべて選択されている
        this.indeterminate = false
        this.isSelectedAllCurrentItems = true
      } else {
        // 一部選択されている
        this.indeterminate = true
        this.isSelectedAllCurrentItems = false
      }
    },

    /**
     * アイテムがクリックされた時の処理
     * @param {Number} value クリックされた値
     */
    $_onClickItem: function (value) {
      if (value === ALL_ITEMS_ID) {
        this.$_toggleIsSelectedAllItems()
      } else if (this.isSelectTypeMultiple) {
        this.$_onClickMultiSelectedItems(value)
      } else {
        this.$_onClickSingleSelectedItem(value)
      }
    },

    /**
     * 単一用のラジオボタンがクリックされた時の処理
     *
     * @param {Number} value クリックされた値
     */
    $_onClickSingleSelectedItem: function (value) {
      if (this.singleSelectedId === value) {
        // 同じアイテムを選択したら選択解除
        this.singleSelectedId = null
      } else {
        this.singleSelectedId = value
      }
    },

    /**
     * 複数用のチェックボックスがクリックされた時の処理
     *
     * @param {Number} value クリックされた値
     */
    $_onClickMultiSelectedItems: function (value) {
      const index = this.multiSelectedIds.findIndex((id) => id === value)
      if (index >= 0) {
        // 選択済みのIDを解除
        this.multiSelectedIds.splice(index, 1)
      } else {
        this.multiSelectedIds.push(value)
      }
    },

    /**
     * 全てのアイテムの選択状態を切り替える
     */
    $_toggleIsSelectedAllItems: function () {
      this.isSelectedAllItems = !this.isSelectedAllItems
    },

    /**
     * ローディングを表示する
     */
    $_showLoading: function () {
      this.isLoading = true
    },

    /**
     * ローディングを非表示にする
     */
    $_hideLoading: function () {
      this.isLoading = false
    },

    /**
     * フルスクリーンローディングを表示する
     */
    $_showLoadingFullScreen: function () {
      this.isLoadingFullScreen = true
      this.isLoading = true
    },

    /**
     * フルスクリーンローディングを非表示にする
     */
    $_hideLoadingFullScreen: function () {
      this.isLoading = false
      this.isLoadingFullScreen = false
    },
  },
}
</script>

<style lang="scss" scoped>
.selected-item-input {
  background-color: #ffffff !important;
  cursor: pointer;
}

.content-inner {
  background-color: #ffffff;
}

.tool-bar {
  width: 100%;
  height: auto;
  padding: 10px;
  box-sizing: border-box;
  background-color: #d9dcdf;
}

.filtering-group {
  margin: 10px 0 0 0;
  display: flex;
  justify-content: center;
  align-items: center;

  .filtering-button-group {
    width: 80%;
  }

  .btn {
    font-size: 0.9em;
    min-width: 4.5em;

    &.btn-light {
      background-color: #f4f5f6;

      &:hover {
        background-color: #e0e1e2;
      }
    }
  }
}

.selector-data-list {
  width: 100%;
  height: 400px;
  overflow: auto;
  overflow-x: hidden;
  @include mixin-scrollbar;
}

.selector-table {
  border-bottom: 1px solid #dee2e6;
  margin-bottom: 0;

  .field {
    position: sticky;
    top: 0;
    border-top: none;
    z-index: 2;

    &.field-checkbox {
      width: 40px;
    }
    &.field-item-id {
      width: 45px;
      text-align: left;
    }
    &.field-item-period {
      width: 35%;
      text-align: left;
    }
    &.field-item-name {
      max-width: calc(100% - 35% - 40px);
      text-align: left;
    }
  }

  .all-item-row:not(:hover) {
    background-color: #ffffdd;
  }
}

.item-col {
  display: flex;
  justify-content: flex-start;
  align-items: bottom;
  text-align: left;

  .item-text {
    margin: 0;
    font-size: 1em;
    line-height: 27px;
    font-weight: bold;
    user-select: none;
  }
}

::v-deep .row-popover {
  .arrow {
    &::after {
      border-right-color: #f0f0f0;
    }
  }

  .popover-body {
    background-color: #f0f0f0;
    border-radius: 4px;
  }

  .item-name {
    font-size: 1em;
    font-weight: bold;
    padding: 10px 10px 5px 1px;
  }

  .list-wrapper {
    margin: 0;
  }
}
</style>
